import { useLanguage } from "../../../i18n/LanguageContext";

export default function QABlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const questionTranslation = getTranslation(
    c.question_zh,
    translated.question
  );

  const answerTranslation = getTranslation(
    c.answer_zh,
    translated.answer
  );

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontWeight: "700",
          marginBottom: "6px",
        }}
      >
        Question
      </div>

      {/* Canonical English */}
      <div style={{ lineHeight: "1.6" }}>
        {c.question_en}
      </div>

      {/* Selected-language learning aid */}
      {questionTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            lineHeight: "1.6",
          }}
        >
          {questionTranslation}
        </div>
      )}

      <div
        style={{
          fontWeight: "700",
          marginTop: "16px",
          marginBottom: "6px",
        }}
      >
        Answer
      </div>

      {/* Canonical English */}
      <div style={{ lineHeight: "1.6" }}>
        {c.answer_en}
      </div>

      {/* Selected-language learning aid */}
      {answerTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            lineHeight: "1.6",
          }}
        >
          {answerTranslation}
        </div>
      )}
    </div>
  );
}